<template>
<div class="container-fluid mt-5">

	<div class="row justify-content-center">

		<div class="col-lg-3 col-md-4 col-sm-6 col-xs-12">

			<h1>Inloggen</h1>

			<b-form @submit.prevent="submit"
			        class="mb-3">

				<b-alert variant="danger"
				         :show="hasError">{{ lastError.message }}</b-alert>

				<b-form-group label-for="email">
					<b-form-input id="email"
					              type="email"
					              v-model="credentials.username"
					              required
					              placeholder="Email"></b-form-input>
				</b-form-group>

				<b-form-group label-for="password">
					<b-form-input id="password"
					              type="password"
					              v-model="credentials.password"
					              required
					              placeholder="Wachtwoord"></b-form-input>
				</b-form-group>

				<b-button size="lg"
				          class="mt-4"
				          block
				          type="submit"
				          variant="primary"
				          v-bind:class="{ disabled: loginPending }">

					<span v-show="loginPending">
					<i class="fas fa-spinner fa-spin"></i>
				</span>
					<span v-show="loginPending == false">Inloggen</span>
				</b-button>

			</b-form>

		</div>

	</div>

</div>
</template>

<script>
import {
	mapActions,
	mapGetters
} from 'vuex'

export default {
	data() {
		return {
			credentials: {
				username: '',
				password: ''
			}
		}
	},
	computed: {
		...mapGetters({
			hasError: 'loginError',
			loginPending: 'loginPending',
			lastError: 'lastError',
			isLoggedIn: 'isLoggedIn'
		})
	},
	watch: {
		isLoggedIn() {
			this.$router.replace('/');
		}
	},
	methods: {
		...mapActions([
			'login'
		]),
		submit() {
			const credentials = {
				username: this.credentials.username,
				password: this.credentials.password
			}

			this.login(credentials);
		}
	}
}
</script>



// WEBPACK FOOTER //
// Login.vue?249c16a6